import { render, staticRenderFns } from "./SettingItemWrap.vue?vue&type=template&id=000bbcba&scoped=true&"
import script from "./SettingItemWrap.vue?vue&type=script&lang=ts&"
export * from "./SettingItemWrap.vue?vue&type=script&lang=ts&"
import style0 from "./SettingItemWrap.vue?vue&type=style&index=0&id=000bbcba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000bbcba",
  null
  
)

export default component.exports